module.exports = "https://bin.bnbstatic.com/_next/static/images/usdt_app_en-eb2b0b819361cfe16466bd7d06fae985.png";